module.exports = __webpack_public_path__ + "img/blockAB31.2abe98a3.svg";